import { toast, Bounce, ToastOptions } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface ToastNotificationProps {
  message: string;
  type?: 'default' | 'info' | 'success' | 'error' | 'warning';
  position?: ToastOptions['position'];
  autoClose?: number;
  hideProgressBar?: boolean;
  closeOnClick?: boolean;
  pauseOnHover?: boolean;
  draggable?: boolean;
  theme?: ToastOptions['theme'];
  transition?: ToastOptions['transition'];
  style?: ToastOptions['style'];
}

export const showToast = ({
  message,
  type = 'default',
  position = 'bottom-left',
  autoClose = 3000,
  hideProgressBar = true,
  closeOnClick = true,
  pauseOnHover = false,
  draggable = true,
  theme = 'light',
  transition = Bounce,
  style = { width: '100%', minWidth: '400px' },
}: ToastNotificationProps) => {
  toast(message, {
    type,
    position,
    autoClose,
    hideProgressBar,
    closeOnClick,
    pauseOnHover,
    draggable,
    theme,
    transition,
    style,
  });
};
